import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=3560d60a&scoped=true&"
var script = {}
import style0 from "./Preloader.vue?vue&type=style&index=0&id=3560d60a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560d60a",
  null
  
)

export default component.exports